import { FormInstance, Row } from "antd";
import { useTitleByMethod } from "../../../hooks/useTitleByMethod";
import { Options } from "./Options";

type MethodsProps = {
  form: FormInstance;
  selectedOption: string;
  selectedItem: any;
  data: any[];
  providerOptions: any;
  setRequest: React.Dispatch<React.SetStateAction<any>>;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
  onDeleted: (id: string) => void;
};

export const Methods = ({
  form,
  selectedOption,
  selectedItem,
  data,
  setRequest,
  setSelectedOption,
  onDeleted,
  providerOptions,
}: MethodsProps) => {
  const { title } = useTitleByMethod(selectedItem);

  return (
    <Row className="d-block mb-8">
      <p className="text w-500 mb-2 mt-0">{title}</p>
      <Row>
        <Options
          form={form}
          selectedOption={selectedOption}
          title={title}
          data={data}
          providerOptions={providerOptions}
          selectedItem={selectedItem}
          setRequest={setRequest}
          setSelectedOption={setSelectedOption}
          onDeleted={onDeleted}
        />
      </Row>
    </Row>
  );
};
